import $ from "jquery";
import Swiper, {
  Autoplay,
  Navigation,
  EffectFade,
  Pagination,
  Scrollbar,
  Mousewheel,
  FreeMode,
} from "swiper";

$(function () {
  Swiper.use([
    Autoplay,
    Navigation,
    EffectFade,
    Pagination,
    Scrollbar,
    FreeMode,
    Mousewheel,
  ]);

  if (document.querySelector(".sponsors-slider")) {
    const swiperSponsors = new Swiper(".sponsors-slider", {
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
        el: ".sponsors-pagination",
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 5,
        },
      },
    });
  }

  if (document.querySelector(".opportunity-slider")) {
    const swiperOpportunity = new Swiper(".opportunity-slider", {
      slidesPerView: 1,
      spaceBetween: 18,
      freeMode: true,
      mousewheel: true,
      scrollbar: {
        el: ".opportunity-scrollbar",
        hide: false,
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }

  if (document.querySelector(".testimonial-slider")) {
    const slides = document.querySelectorAll(
      ".testimonial-slider .swiper-slide"
    );

    if (slides.length > 1) {
      const swiperTestimonial = new Swiper(".testimonial-slider", {
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        navigation: {
          nextEl: ".testimonial-button-next",
          prevEl: ".testimonial-button-prev",
        },
      });
    } else {
      const nextBtn = document.querySelector(".testimonial-button-next");
      const prevBtn = document.querySelector(".testimonial-button-prev");
      if (nextBtn) nextBtn.style.display = "none";
      if (prevBtn) prevBtn.style.display = "none";
    }
  }
});
